<template>
  <div
    class="fts-release-badge"
    :class="{ 'release-badge--primary': newRelease || upcoming }"
  >
    {{getBadgeLabel}}
  </div>
</template>

<script>
import { ReleaseStage } from '../commons/enum';

export default {
  props: {
    badgeLabel: String,
    stage: String,
    alpha: Boolean,
    beta: Boolean,
    upcoming: Boolean,
    newRelease: Boolean,
    dev: Boolean,
  },
  computed: {
    getBadgeLabel() {
      if (this.badgeLabel)
        return this.badgeLabel;
      else if (this.alpha || this.stage === ReleaseStage.ALPHA)
        return "Alpha";
      else if (this.stage === ReleaseStage.BETA)
        return "Beta";
      else if (this.dev || this.stage === ReleaseStage.DEVELOPMENT)
        return "Dev";
      else if (this.upcoming)
        return "Coming Soon";
      else if (this.newRelease)
        return "New";
      else
        return "Beta";
    },
  }
}
</script>

<style lang="scss">
.fts-release-badge {
  height: 0.875rem;
  display: inline-flex;
  padding: 0 0.25rem;
  border-radius: 0.125rem;
  background-color: var(--fts-gray-100);
  color: var(--fts-gray-700);
  text-transform: uppercase;
  font-weight: 500;
  font-style: normal;
  font-size: 0.625rem;
  line-height: 0.875rem;
  white-space: normal;
  &.release-badge--primary {
    background-color: rgba(var(--fts-primary-rgb), 0.12);
    color: var(--fts-primary);
  }
  /* to-do remove */
  &.editor-tool-rb {
    position: absolute;
    top: -3px;
    right: 0;
  }
}
</style>